import React from "react"
import ReactMapboxGl, { Marker, ZoomControl } from "react-mapbox-gl"
import MarkerIcon from "../../../static/circle-map-pin.svg"
import styled from "styled-components"

import Placeholder from "./Placeholder"
import { fadeIn } from "../Animation"

let Map = false

if (typeof window !== `undefined`) {
  Map = ReactMapboxGl({
    dragPan: false,
    scrollZoom: false,
    accessToken:
      "pk.eyJ1IjoiYmFyZWFkdmVydGlzaW5nIiwiYSI6ImNqaWRmdDMxZDAxdWw0MW9jYXRjYWRqZ3QifQ.DPR-gLvJOZzyf4X-Yk3V0g"
  })
}

const containerStyle = {
  maxHeight: "300px",
  minHeight: "200px",
  height: "25vw",
  width: "100%"
}

const MapBox = ({ map: location }) => {
  return (
    <Container>
      <Placeholder containerStyle={containerStyle} />

      {Map && location && (
        <Map
          // eslint-disable-next-line
          style="mapbox://styles/bareadvertising/cjvfk08hk06k61fqsjd02ydhq"
          containerStyle={containerStyle}
          zoom={[12]}
          center={[location.lng, location.lat - -0.0035]}
        >
          <Marker
            style={{ pointerEvents: "none" }}
            coordinates={[location.lng, location.lat]}
            anchor="bottom"
          >
            <MarkerIcon />
          </Marker>
          <ZoomControl position={"top-left"} />
        </Map>
      )}
    </Container>
  )
}

export default MapBox

const Container = styled.div`
  position: relative;
  animation: ${fadeIn} 150ms ease-in-out 0s normal;
`
